export const TLCustomisations = {
    customiseCreateFormData: (formData, licenceObject) => licenceObject,
    customiseRenewalCreateFormData: (formData, licenceObject) => licenceObject,
    customiseSendbackFormData: (formData, licenceObject) => licenceObject
}